
import { Options, Vue } from "vue-class-component";
import PageWrapper from "@/layout/pageWrapper/index.vue";
import { languagesModule } from "@/store";

@Options({
  name: "Settings",
  components: { PageWrapper },
})
export default class Settings extends Vue {
  created(): void {
    languagesModule.Load();
  }
}
